import { FileBlock } from '@lighthouse/block/src/blocks'
import { type FileBlockAbstract } from '@lighthouse/core'
import { isFileValue } from '@lighthouse/shared'
import React, { useMemo } from 'react'

import { useParseVariableWithSubscription } from '@/hooks/useParseVariable'

interface FileBlockControllerProps extends React.ComponentPropsWithoutRef<'div'> {
    blockData: FileBlockAbstract
}

const FileBlockController: React.FunctionComponent<FileBlockControllerProps> = ({ blockData, ...rest }) => {
    const {
        config: { fileSource }
    } = blockData

    const parseVariable2Field = useParseVariableWithSubscription(fileSource)

    const value = useMemo(() => {
        if (!fileSource) {
            return []
        }

        const file = parseVariable2Field(fileSource)

        if (file) {
            const fileValue = file.value

            return isFileValue(fileValue) ? fileValue : []
        }
        return []
    }, [fileSource, parseVariable2Field])

    return <FileBlock blockData={blockData} value={value} {...rest} />
}

export default FileBlockController
